import { Button } from "./ui/button.tsx";
import { Smartphone, Heart, Shield } from "lucide-react";

const HeroSection = () => {
  return (
    <section 
      className="relative py-20 px-4 bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `url('/img/wasser.jpg')`,
        minHeight: '100vh'
      }}
    >
      {/* Dark overlay for better text readability */}
      <div className="absolute inset-0 bg-black bg-opacity-40"></div>
      
      {/* Content */}
      <div className="relative z-10 max-w-6xl mx-auto text-center">
        <div className="flex justify-center mb-8">
          <div className="bg-white bg-opacity-90 p-4 rounded-full">
            <Heart className="w-12 h-12 text-blue-600" />
          </div>
        </div>
        
        <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">
          Sie müssen nicht jeden Tag anrufen,<br />
          <span className="text-blue-200">um sicher zu sein.</span>
        </h1>

        <p className="text-xl md:text-2xl text-gray-100 mb-8 max-w-4xl mx-auto leading-relaxed">
          Wir schreiben Ihrer Mutter oder Ihrem Vater jeden Tag eine kurze Nachricht.
          Kommt keine Antwort, erfahren Sie es sofort – per WhatsApp oder SMS.
          Kein Gerät, keine App, keine Installation.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8">
          <a href="/register?fuer=angehoeriger">
          <Button size="lg" className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 text-lg rounded-full min-w-[260px] shadow-lg">
            Für einen Angehörigen einrichten
          </Button></a>
          <a href="/register?fuer=selbst">
          <Button variant="outline" size="lg" className="border-white text-white hover:bg-white hover:text-gray-900 px-8 py-4 text-lg rounded-full min-w-[260px] bg-white bg-opacity-10 backdrop-blur-sm">
            Für mich selbst einrichten
          </Button></a>
        </div>

        {/* Markensatz – traegt den Domainnamen */}
        <p className="text-lg md:text-xl text-blue-100 mb-12 max-w-3xl mx-auto">
          Jeden Tag die vier Worte, auf die es ankommt:{" "}
          <span className="font-semibold text-white">Es geht mir gut.</span>
        </p>
        
        <div className="flex flex-col md:flex-row items-center justify-center gap-8 text-gray-100">
          <div className="flex items-center gap-2">
            <Smartphone className="w-5 h-5 text-green-300" />
            <span>Kein Gerät nötig</span>
          </div>
          <div className="flex items-center gap-2">
            <Shield className="w-5 h-5 text-green-300" />
            <span>Sie hören nur, wenn etwas ist</span>
          </div>
          <div className="flex items-center gap-2">
            <Heart className="w-5 h-5 text-green-300" />
            <span>In 3 Minuten eingerichtet</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
